import React, { Component } from 'react'
import { connect } from 'react-redux'

// Actions
import { GetCarRental, UpdateCarRental, GetOpenCarRentalNumbers } from '../../../actions/shops'
import { GetCarClasses, GetCarTypes } from '../../../actions/carrental'
import { getOrderVehicleData } from '../../../actions/orders'

// Elements
import Col from '../../../shared/elements/col'
import Panel from '../../../shared/elements/panel'
import Text from '../../../shared/elements/text'
import Switch from '../../../shared/elements/switch'
import DropDown from '../../../shared/elements/dropDown'
import TextArea from '../../../shared/elements/textarea'

// Utils
import { translation } from '../../../utils/helpers'
import { hasSubscriptionPermission } from '../../../utils/auth'

// contants
import { CarRentalSystemTypes } from '../../../constants'

// import styles
import './view.scss'
import CarRentalLog from '../CarRentalLog'
import TempInoperative from '../TempInoperative'

class View extends Component {

  constructor (props) {
    super(props)
    this.state = {
      type: 'create',
      carRental: {
        Id: 0,
        RegNumber: '',
        BrandName: '2000',
        Number: 0,
        Model: '',
        Name: '',
        Type: 0,
        Category: 0,
        Color: '',
        Comment: '',
        Active: true
      },
      openNumbers: [],
      carTypes: [],
      carCategories: []
    }
    this.onChange = this.onChange.bind(this)
    this.onBlur = this.onBlur.bind(this)
    this.getCarRental = this.getCarRental.bind(this)
    this.updateCarRental = this.updateCarRental.bind(this)
    this.getOpenCarRentalNumbers = this.getOpenCarRentalNumbers.bind(this)
    this.getOrderVehicleData = this.getOrderVehicleData.bind(this)
    this.getCarClasses = this.getCarClasses.bind(this)
    this.getCarTypes = this.getCarTypes.bind(this)
  }

  componentDidMount () {
    this.getCarRental(this.props.itemId)
    this.getOpenCarRentalNumbers()
    this.getCarTypes()
    this.getCarClasses()
  }

  componentWillReceiveProps (nextProps) {
    this.getCarRental(nextProps.itemId)
    this.getOpenCarRentalNumbers()
    this.getCarTypes()
    this.getCarClasses()
  }

  getCarRental (itemId) {
    if (typeof itemId !== 'undefined' && itemId > 0) {
      this.props.GetCarRental(itemId).then((res) => {
        this.setState({
          type: 'edit',
          carRental: res.data
        })
      })
    } else {
      this.resetCreate()
    }
  }

  getOpenCarRentalNumbers () {
    this.props.GetOpenCarRentalNumbers().then((res) => {
      this.setState({
        openNumbers: res.data
      })
    })
  }

  getCarTypes () {
    this.props.GetCarTypes().then((res) => {
      this.setState({
        carTypes: res.data
      })
    })
  }

  getCarClasses () {
    this.props.GetCarClasses().then((res) => {
      this.setState({
        carCategories: res.data
      })
    })
  }

  resetCreate () {
    this.setState({
      type: 'create',
      carRental: {
        Id: 0,
        RegNumber: '',
        BrandName: '2000',
        Number: 0,
        Model: '',
        Color: '',
        Comment: '',
        Active: true
      }
    })
  }

  updateCarRental () {
    let carRental = this.state.carRental

    let errText = ''
    if (carRental.RegNumber === '') {
      errText = translation('14774')
    }
    // if (carRental.Number === 0 && carRental.Active) {
    //   errText += '<br>' + translation('14786')
    // }
    if (errText !== '') {
      window.toastr.error(translation(errText), translation('216'))
    } else {
      this.props.UpdateCarRental(carRental).then((res) => {
        this.setState({
          carRental: {
            ...this.state.carRental,
            Number: res.data.Number
          }
        })
        this.props.onSave(res.data, this.state.type)
        setTimeout(() => {
          this.props.GetSimpleCarRentals()
          this.getOpenCarRentalNumbers()
        }, 0)
      }, (err) => {
        if (err.response.data !== undefined) {
          let error = err.response.data
          if (error.Message) {
            error = error.Message
          }
          this.getCarRental(carRental.Id)

          // Toastr
          window.toastr.error(translation(error), translation('216'))
        }
      })
    }
  }

  onChange (e) {
    if (typeof e.persist === 'function') e.persist()
    let value = e.target.value
    if (e.target.type === 'checkbox') {
      value = e.target.checked
    }
    if (e.target.type === 'radio') {
      value = (e.target.value === 'yes')
    }

    if (e.target.name === 'Type' || e.target.name === 'Category') {
      value = (value === '0' || value === 0) ? null : parseInt(value)
    }

    this.setState({
      type: this.state.type,
      carRental: {
        ...this.state.carRental,
        [e.target.name]: value
      }
    }, () => {
      if (e.target.type !== 'text') {
        this.onBlur(e)
      }
    })
  }

  onBlur (e) {
    if (e.target.name === 'RegNumber') {
      this.getOrderVehicleData(e.target.value)
    }
    if (this.state.carRental.Id !== undefined && this.state.carRental.Id > 0) {
      this.updateCarRental()
    }
  }

  renderCarRental () {
    let carRental = this.state.carRental
    const { carTypes, carCategories } = this.state
    // const { carTypes, carCategories } = this.props
    const hasPerm = hasSubscriptionPermission(this.props.auth, 10, 11)
    const readOnlyIsActive = this.state.carRental.IsAssigned || !hasPerm || this.state.carRental.HasServicePeriodNowOrFuture
    let isActiveHelpText
    if (this.state.carRental.IsAssigned) isActiveHelpText = 15109
    else if (this.state.carRental.HasServicePeriodNowOrFuture) isActiveHelpText = 17923

    if (carRental === undefined) return null
    const brandsList = (val, key) => {
      return (
        <option key={key} value={val.Name}>{translation(val.Name)}</option>
      )
    }

    const renderOpenNumbers = () => {
      return this.state.openNumbers.reduce((numbers, num, key) => {
        if (num !== '' && num !== carRental.Number) {
          let opt = <option key={key} value={num}>{num}</option>
          return [...numbers, opt]
        }
        return numbers
      }, [])
    }

    let vanCategories = [3, 4, 5]
    let passengerCategories = [1, 2, 4, 5]
    let panelTitle = ''
    let disabledForRentLog = this.props.auth.carRentalSystem === CarRentalSystemTypes.RENTLOG

    const renderTypes = (val, key) => {
      return (
        <option key={key} value={val.Id}>{val.Name}</option>
      )
    }

    const renderCategories = (category, key) => {
      let cat = parseInt(category.Id)

      if (this.props.auth.carRentalSystem === CarRentalSystemTypes.RENTLOG) {
        return <option key={key} value={cat}>{category.Name}</option>
      }

      if (carRental.Type === null || carRental.Type === 1 && vanCategories.includes(cat) || carRental.Type === 2 && passengerCategories.includes(cat)) {
        return <option key={key} value={cat}>{category.Name}</option>
      }
    }

    if (this.state.type === 'create') panelTitle = translation('629')
    else if (this.state.type === 'edit') panelTitle = carRental.RegNumber + ', ' + carRental.BrandName + ', ' + carRental.Model
    return (
      <Panel title={panelTitle}>
        <Text name='RegNumber' value={carRental.RegNumber || ''} onChange={this.onChange} onBlur={this.onBlur} disabled={this.state.type === 'edit' || disabledForRentLog} labelText={translation('2005')} />
        <DropDown name='BrandName' onChange={this.onChange} value={carRental.BrandName} disabled={this.state.type === 'edit' || disabledForRentLog} labelText={translation('145')}>
          {this.props.brands.map(brandsList)}
        </DropDown>
        <Text name='Model' value={carRental.Model || ''} onChange={this.onChange} onBlur={this.onBlur} disabled={this.state.type === 'edit' || disabledForRentLog} labelText={translation('146')} />
        <Text name='Name' value={carRental.Name || ''} onChange={this.onChange} onBlur={this.onBlur} disabled={!hasPerm || disabledForRentLog} labelText={translation('30')} />
        <DropDown name='Type' onChange={this.onChange} value={carRental.Type || 0} disabled={!hasPerm || disabledForRentLog} labelText={translation('332')}>
          <option value={0} />
          {carTypes.map(renderTypes)}
        </DropDown>
        <DropDown name='Category' onChange={this.onChange} value={carRental.Category || 0} disabled={!hasPerm || disabledForRentLog} labelText={translation('1230')}>
          <option value={0} />
          {carCategories.map(renderCategories)}
        </DropDown>
        <Text name='Color' value={carRental.Color || ''} onChange={this.onChange} onBlur={this.onBlur} disabled={!hasPerm || disabledForRentLog} labelText={translation('179')} />
        {this.state.openNumbers !== undefined && (
          <DropDown name='Number' onChange={this.onChange} value={carRental.Number} disabled={!carRental.Active || !hasPerm || disabledForRentLog} labelText={translation('1309')}>
            <option value={carRental.Number}>{carRental.Number || translation('1309')}</option>
            {renderOpenNumbers()}
          </DropDown>
        )}
        <TextArea name='Comment' onChange={this.onChange} onBlur={this.onBlur} value={carRental.Comment || ''} disabled={!hasPerm || disabledForRentLog} labelText={translation('93')} />
        <Switch name='Active' onChange={this.onChange} checked={carRental.Active} labelText={translation('295')} disabled={readOnlyIsActive || disabledForRentLog} helpText={translation(isActiveHelpText)} />
        {/* <YesNoRadioGroup router={this.props.router} onChange={this.onChange} name='Active' stateValue={carRental.Active} title='295' canChange={canChange} readOnly={readOnly} onClick={onClick} /> */}
      </Panel>
    )
  }

  getOrderVehicleData (regNumber) {
    this.props.getOrderVehicleData(regNumber, 'RegNumber').then((res) => {
      this.setState({
        carRental: {
          ...this.state.carRental,
          RegNumber: res.data.RegNr,
          BrandName: res.data.BrandName,
          Model: res.data.Model
        }
      })
      let dictionaryKeyResult = res.data.DictionaryKey
      if (dictionaryKeyResult === 1153) {
        dictionaryKeyResult = 14862
      }
      if (dictionaryKeyResult) {
        // Toastr
        window.toastr.info(translation(dictionaryKeyResult))
      }
    }, (err) => {
      // Toastr
      window.toastr.error(translation(err.response.data.DictionaryKey), translation('216'))
    })
  }

  render () {
    let classNameList = (this.state.type === 'edit') ? 'view_edit' : 'view_create'
    return (
      <div className={classNameList}>
        <div className='row clearfix'>
          <Col>
            {this.renderCarRental()}
          </Col>
          <Col>
            {this.state.type === 'edit' && hasSubscriptionPermission(this.props.auth, 20) && <CarRentalLog router={this.props.router} rentalCarId={this.props.itemId} />}
          </Col>
          <Col>
            {this.state.type === 'edit' && this.props.auth.carRentalSystem === CarRentalSystemTypes.NONE && hasSubscriptionPermission(this.props.auth, 20) && <TempInoperative rentalCarId={this.props.itemId} OnUpdateCallback={() => this.getCarRental(this.props.itemId)} />}
          </Col>
        </div>
      </div>
    )
  }
}

function mapStateToProps (state) {
  return {
    auth: state.auth,
    // carTypes: state.common.enums_new.CarRentalTypes,
    // carCategories: state.common.enums_new.CarRentalCategories,
    brands: state.common.brands
  }
}

export default connect(mapStateToProps, {
  GetCarRental,
  UpdateCarRental,
  GetOpenCarRentalNumbers,
  getOrderVehicleData,
  GetCarTypes,
  GetCarClasses
}, null, { withRef: true })(View)



// WEBPACK FOOTER //
// ./src/app/pages/CarRental/View/index.js